<template>
	<div class="glow-container">
		<div class="glow-gradient"></div>
	</div>
	<div class="button-background"></div>
	<div class="button-text" v-html="sanitizeButton(buttonText)"></div>
	<Transition name="fade-opacity">
		<div v-if="showLoader" class="loader"></div>
	</Transition>
	<slot />
</template>

<script setup>
import { useSanitize } from '~~/composables/useSanitize.js';
const { sanitizeButton } = useSanitize();
const props = defineProps({
	data: { type: Object, required: true },
	showLoader: { type: Boolean, default: false }
});

const buttonText = props.data?.text || props.data?.content[0]?.value;
</script>
